
try {
  process.dlopen(module, require("path").join(__dirname, __webpack_public_path__, "java.linux-x64-gnu.node"));
} catch (error) {
  throw new Error('node-loader:\n' + error);
}
